<template>
  <div class="page-wrapper">
    <div class="title-box">
      <Title title="九吨福利"></Title>
    </div>

    <div class="content">
      <div class="item" :class="item.type == 1 ? 'actived' : ''" v-for="(item, index) in list" :key="index">
        <h1 class="num">{{ item.num }}</h1>
        <h1 class="title">
          {{ item.title }}
        </h1>
        <p class="desc">
          {{ item.desc }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/mobile/Title'
export default {
  components: {
    Title
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const [err, res] = await this.$http.get('welfare')
      if (err) return
      for (let i = 0; i < res.list.length; i++) {
        const element = res.list[i];
        // 加上数字文本
        element.num = '0' + (i + 1)
        // 加上选中样式进行区分
        let index_arr = [0, 3, 4]
        if (index_arr.indexOf(i) > -1) {
          element.type = 1
        }
      }
      this.list = res.list
    },
  }

}
</script>

<style scoped lang="less">
.page-wrapper {
  position: relative;
  background: #FFF;
  padding-top: 1.76rem;
  color: #000000;
  font-size: .2667rem;
  box-sizing: border-box;

  .title-box {
    padding: 0 .5333rem 0 .5333rem;
    box-sizing: border-box;
  }

  .content {
    margin-top: 2.3333rem;
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 50%;
      height: 5.0933rem;
      box-sizing: border-box;
      padding: .6667rem .72rem 0 .4rem;
      background-color: #FFF;

      .num {
        color: rgba(266, 139, 43, 0.3);
        font-weight: bold;
        font-size: 1.0667rem;
        margin-bottom: .4667rem;
      }

      .title {
        font-weight: bold;
        font-size: .4267rem;
        margin-bottom: .2rem;
      }

      .desc {
        font-size: .3467rem;
        color: #333;
      }
    }

    .actived {
      background: #FBFBFB;
    }
  }
}
</style>